// extracted by mini-css-extract-plugin
export default {"row":"createEvent_row__2z238","col":"createEvent_col__nbLm8","card":"createEvent_card__d7nIN"};